/*
This file was created by the script build.py 
*/

import {getAllFiltered} from "./filter";
import {searchObjectFinalStatesSignature} from "./searchObjects"



export function fillSearchObjectFinalStatesSignature(){
    searchObjectFinalStatesSignature.categories = [];
    searchObjectFinalStatesSignature.keywords = [];

    const checkbox = document.getElementById("categoryFinalStatesSignature");
    if(checkbox.checked || checkbox.indeterminate){
        searchObjectFinalStatesSignature.categories.push(checkbox.value);
    }

    const anyButton = document.getElementById("buttonFinalStatesSignatureAny");
    if(anyButton.classList.contains("chosen")){
        searchObjectFinalStatesSignature.any = true;
    }

    const allButton = document.getElementById("buttonFinalStatesSignatureAll");
    if(allButton.classList.contains("chosen")){
        searchObjectFinalStatesSignature.any = false;
    }
    
    const buttonBHadrons = document.getElementById("buttonFinalStatesSignatureBHadrons");
    if(buttonBHadrons.classList.contains('selected')){
        searchObjectFinalStatesSignature.keywords.push(buttonBHadrons.value)
    }
    
    const buttonCHadrons = document.getElementById("buttonFinalStatesSignatureCHadrons");
    if(buttonCHadrons.classList.contains('selected')){
        searchObjectFinalStatesSignature.keywords.push(buttonCHadrons.value)
    }
    
    const buttonDetectorperformance = document.getElementById("buttonFinalStatesSignatureDetectorperformance");
    if(buttonDetectorperformance.classList.contains('selected')){
        searchObjectFinalStatesSignature.keywords.push(buttonDetectorperformance.value)
    }
    
    const buttondiBoson = document.getElementById("buttonFinalStatesSignaturediBoson");
    if(buttondiBoson.classList.contains('selected')){
        searchObjectFinalStatesSignature.keywords.push(buttondiBoson.value)
    }
    
    const buttondiHiggs = document.getElementById("buttonFinalStatesSignaturediHiggs");
    if(buttondiHiggs.classList.contains('selected')){
        searchObjectFinalStatesSignature.keywords.push(buttondiHiggs.value)
    }
    
    const buttonElectron = document.getElementById("buttonFinalStatesSignatureElectron");
    if(buttonElectron.classList.contains('selected')){
        searchObjectFinalStatesSignature.keywords.push(buttonElectron.value)
    }
    
    const buttonHiggsbosons = document.getElementById("buttonFinalStatesSignatureHiggsbosons");
    if(buttonHiggsbosons.classList.contains('selected')){
        searchObjectFinalStatesSignature.keywords.push(buttonHiggsbosons.value)
    }
    
    const buttonLongLivedsignature = document.getElementById("buttonFinalStatesSignatureLongLivedsignature");
    if(buttonLongLivedsignature.classList.contains('selected')){
        searchObjectFinalStatesSignature.keywords.push(buttonLongLivedsignature.value)
    }
    
    const buttonMissingenergyInvisible = document.getElementById("buttonFinalStatesSignatureMissingenergyInvisible");
    if(buttonMissingenergyInvisible.classList.contains('selected')){
        searchObjectFinalStatesSignature.keywords.push(buttonMissingenergyInvisible.value)
    }
    
    const buttonMuon = document.getElementById("buttonFinalStatesSignatureMuon");
    if(buttonMuon.classList.contains('selected')){
        searchObjectFinalStatesSignature.keywords.push(buttonMuon.value)
    }
    
    const buttonPhoton = document.getElementById("buttonFinalStatesSignaturePhoton");
    if(buttonPhoton.classList.contains('selected')){
        searchObjectFinalStatesSignature.keywords.push(buttonPhoton.value)
    }
    
    const buttonTaggedproton = document.getElementById("buttonFinalStatesSignatureTaggedproton");
    if(buttonTaggedproton.classList.contains('selected')){
        searchObjectFinalStatesSignature.keywords.push(buttonTaggedproton.value)
    }
    
    const buttonTau = document.getElementById("buttonFinalStatesSignatureTau");
    if(buttonTau.classList.contains('selected')){
        searchObjectFinalStatesSignature.keywords.push(buttonTau.value)
    }
    
    const buttonTop = document.getElementById("buttonFinalStatesSignatureTop");
    if(buttonTop.classList.contains('selected')){
        searchObjectFinalStatesSignature.keywords.push(buttonTop.value)
    }
    
    const buttonTracks = document.getElementById("buttonFinalStatesSignatureTracks");
    if(buttonTracks.classList.contains('selected')){
        searchObjectFinalStatesSignature.keywords.push(buttonTracks.value)
    }
    
    const buttontriAndmultibosons = document.getElementById("buttonFinalStatesSignaturetriAndmultibosons");
    if(buttontriAndmultibosons.classList.contains('selected')){
        searchObjectFinalStatesSignature.keywords.push(buttontriAndmultibosons.value)
    }
    
    const buttonttbarAnythingbutHiggs = document.getElementById("buttonFinalStatesSignaturettbarAnythingbutHiggs");
    if(buttonttbarAnythingbutHiggs.classList.contains('selected')){
        searchObjectFinalStatesSignature.keywords.push(buttonttbarAnythingbutHiggs.value)
    }
    
    const buttonttbarHiggsboson = document.getElementById("buttonFinalStatesSignaturettbarHiggsboson");
    if(buttonttbarHiggsboson.classList.contains('selected')){
        searchObjectFinalStatesSignature.keywords.push(buttonttbarHiggsboson.value)
    }
    
    const buttonWboson = document.getElementById("buttonFinalStatesSignatureWboson");
    if(buttonWboson.classList.contains('selected')){
        searchObjectFinalStatesSignature.keywords.push(buttonWboson.value)
    }
    
    const buttonZboson = document.getElementById("buttonFinalStatesSignatureZboson");
    if(buttonZboson.classList.contains('selected')){
        searchObjectFinalStatesSignature.keywords.push(buttonZboson.value)
    }
    
    getAllFiltered()

}